var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandyCorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9628 9.06214L13.0915 11.4653C15.4644 10.3878 17.6069 8.85279 19.395 6.94605L17.1558 5.38635C15.6047 6.85445 13.8555 8.09143 11.9628 9.06214Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4871 4.22394C14.0902 5.4928 12.5268 6.56119 10.8422 7.39987C10.456 7.07132 10.0004 6.83069 9.50913 6.69618L9.31552 4.36075C9.25286 3.60497 9.63912 2.87388 10.3049 2.48799L10.681 2.27001C11.3469 1.88413 12.1707 1.91389 12.7914 2.34624L15.4871 4.22394Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0406 8.09238C19.0421 10.2822 16.6245 12.0411 13.9373 13.266L15.0217 15.5749C17.4089 14.6712 19.5789 13.252 21.3692 11.4152C22.3131 10.4467 22.18 8.88601 21.0886 8.12579L21.0406 8.09238Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77942 16.8258L2.22822 17.9994C1.5804 19.3787 2.36915 20.9968 3.8689 21.3653L4.39984 21.4957C7.32506 22.2143 10.3912 22.1641 13.2904 21.3501C14.4708 21.0187 15.1252 19.8187 14.8114 18.6977C10.6973 19.2273 6.52555 18.5735 2.77942 16.8258Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62512 15.0253C6.84489 16.5253 10.4098 17.1371 13.9492 16.7922L12.7289 14.1941C9.98784 14.1854 7.27461 13.6732 4.72337 12.6869L3.62512 15.0253Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5715 10.8811C7.56121 11.6341 9.65672 12.072 11.7821 12.1782L10.379 9.19091C10.0568 8.50495 9.35816 8.06567 8.58933 8.06567H8.15503C7.38621 8.06567 6.68755 8.50495 6.36537 9.19091L5.5715 10.8811Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandyCorn);
export default __webpack_public_path__ + "static/media/candy-corn.fab150ae5ac00d8ee8a50efc22f756a7.svg";
export { ForwardRef as ReactComponent };